import tagsApi from '@/api/v1/tags';

export default {
  namespaced: true,

  state: {
    tags: [],
  },

  mutations: {
    SET_TAGS(state, tags) {
      state.tags = tags;
    },

    ADD_TAG(state, tag) {
      state.tags = [...state.tags, tag];
    },

    UPDATE_TAG(state, { id, data }) {
      const copiedTags = [...state.tags];
      const tagIndex = copiedTags.findIndex((tag) => tag.id === id);
      copiedTags[tagIndex] = data;
      state.tags = copiedTags;
    },

    REMOVE_TAG(state, id) {
      state.tags = state.tags.filter((tag) => tag.id !== id);
    },

    CHANGE_PROCESSING_STATUS(state, status) {
      state.isProcessing = status;
    },
  },

  actions: {
    fetchTags({ commit }) {
      commit('CHANGE_LOADING_STATUS', true, { root: true });

      tagsApi.index()
        .then((response) => {
          commit('SET_TAGS', response.data);
        })
        .finally(() => {
          commit('CHANGE_LOADING_STATUS', false, { root: true });
        });
    },

    createTag({ commit }, tag) {
      commit('CHANGE_PROCESSING_STATUS', true);

      tagsApi.create(tag)
        .then((response) => {
          commit('ADD_TAG', response.data);
        })
        .finally(() => {
          commit('CHANGE_PROCESSING_STATUS', false);
        });
    },

    updateTag({ commit }, { tag, id }) {
      commit('CHANGE_PROCESSING_STATUS', true);

      tagsApi.update(id, tag)
        .then((response) => {
          commit('UPDATE_TAG', { id, data: response.data });
        })
        .finally(() => {
          commit('CHANGE_PROCESSING_STATUS', false);
        });
      },

      deleteTag({ commit }, id) {
        commit('CHANGE_PROCESSING_STATUS', true);

        tagsApi.delete(id)
          .then(() => {
            commit('REMOVE_TAG', id);
          })
          .finally(() => {
            commit('CHANGE_PROCESSING_STATUS', false);
          });
    },

  },
};
